import { Link } from 'react-router-dom';
import { CATEGORY_ALL } from '@/mocks';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-500/10 text-primary-500 border-primary-500/20 hover:bg-primary-500/20 hover:border-primary-500/40',
  accent: 'bg-accent-500/10 text-accent-500 border-accent-500/20 hover:bg-accent-500/20 hover:border-accent-500/40',
  secondary: 'bg-secondary-500/10 text-secondary-500 border-secondary-500/20 hover:bg-secondary-500/20 hover:border-secondary-500/40',
};

export default function CategoryNav() {
  return (
    <section className="px-4 md:px-6 -mt-8 relative z-10">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3">
          {CATEGORY_ALL.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex flex-col items-center gap-2 p-4 rounded-lg border backdrop-blur-sm transition-all duration-300 ${colorMap[cat.color]}`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-xs font-medium whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}